import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AdsService } from './ads.service';
import { Ad } from '../../models/ad.model';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Browser } from '@capacitor/browser';
import { AdType } from '../../models/enums/ad-type';

@Component({
  standalone: false,
    selector: 'app-ads',
    templateUrl: './ads.component.html',
    styleUrls: ['./ads.component.scss'],
})
export class AdsComponent implements OnInit, OnDestroy {

    @Input() adType: AdType;
    @Input() pageId: string;

    ads: Ad[];
    private readonly destroy$: Subject<void> = new Subject();
    isLoading: boolean;

    constructor(
        private adsService: AdsService,
        private router: Router
    ) { }

    ngOnInit() {
        this.getAds();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    getAds() {
        this.isLoading = true;
        const filter = {
            date: new Date(),
            adType: this.adType,
            pageId: this.pageId
        };

        this.adsService
            .getAds(filter)
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.isLoading = false)
            )
            .subscribe(
                res => {
                    this.ads = res.data.ads;
                }
            );

    }

    async openUrl(ad: Ad) {
        if (ad.url) {
            ad.url.includes('http')
                ? await Browser.open({ url: ad.url })
                : this.router.navigate([ad.url]);
        }
    }

}
